import styled from 'styled-components'

const DockItemPanelOffline = styled.div`
  opacity: 0.6;
  pointer-events: none;
`

export default DockItemPanelOffline
